export type UIIconName =
  | "HOME"
  | "BIN"
  | "BORDER"
  | "COLLECTIONS"
  | "DRAG-HANDLE"
  | "GPS"
  | "LABEL-DECORATION-NONE"
  | "LABEL-DECORATION-LINE"
  | "LABEL-DECORATION-BRACKET"
  | "LABEL-DECORATION-CORNER"
  | "LABEL-DECORATION-BORDER"
  | "LABEL-DECORATION-DOT"
  | "LINE-STYLE"
  | "MAP"
  | "PENCIL"
  | "POINT"
  | "POINT-STYLE"
  | "PROJECTS"
  | "FOLDER"
  | "REMOVE"
  | "SIZE"
  | "STATIC-LABEL"
  | "BACKDROP"
  | "TEMPLATES"
  | "USER"
  | "MAP-LABEL"
  | "CHEVRON-LEFT"
  | "CHEVRON-RIGHT"
  | "CHEVRON-UP"
  | "CHEVRON-DOWN"
  | "LINE-STYLE-SINGLE"
  | "LINE-STYLE-FLANKED"
  | "LINE-STYLE-TRANSLUCENT"
  | "TEXT-ALIGN-LEFT"
  | "TEXT-ALIGN-CENTER"
  | "TEXT-ALIGN-RIGHT"
  | "COPY"
  | "SIGN-IN"
  | "SIGN-OUT"
  | "MAIN-MENU"
  | "PLUS"
  | "CHECK"
  | "CHECK-UNCHECKED"
  | "CHECK-FILLED"
  | "BAG"
  | "PHOTO"
  | "PHOTO-LABEL"
  | "TEXT-CASE-ON"
  | "TEXT-CASE-OFF"
  | "IPHONE"
  | "IPHONE-UPLOAD"
  | "IPHONE-POINT"
  | "IPHONE-ROUTE"
  | "IPHONE-ACTIVITY"
  | "ELIPSIS"
  | "STRAVA"
  | "EYE"
  | "EYE-CLOSED"
  | "INFO"
  | "MAGNIFYING-EXCLAMATION"
  | "DOWNLOAD"
  | "BULB"
  | "PERSON";

export type UIIconVariant = "REGULAR" | "HIGHLIGHTED" | "SELECTED" | "CONTRAST";

export const iconPath = (icon: UIIconName, variant: UIIconVariant) => {
  const path = "/icons/UI-ICONS/" + variant + "/UI-ICON-" + icon + ".png";
  return path;
};
